import { AlertModal } from '@/globalComponents/alertModal';
import React from 'react';

interface ErrorModalProps {
  isError: boolean;
  buttonText?: string;
  setIsError: (value: boolean) => void;
}

export const ErrorModal = (props: ErrorModalProps) => {
  const { isError, setIsError, buttonText = 'Retry' } = props;
  // istanbul ignore next
  return (
    <AlertModal
      open={isError}
      title={'Something went wrong'}
      buttonText={buttonText}
      onButtonClick={() => setIsError(false)}
      severity="error"
      onClose={() => {}}
    />
  );
};
